import React, { Fragment, useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import { makeStyles } from "@material-ui/core/styles";
import { DataStore } from "@aws-amplify/datastore";
import { EyepieceThreeResponse, Users } from "models";
import { Auth } from "aws-amplify";
import { Container } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(2),
  },
}));
function EyepieceThreeSurvey() {
  const classes = useStyles();

  const [submitted, setSubmitted] = useState();
  const [school, setSchool] = useState();

  useEffect(async () => {
    const user = await Auth.currentAuthenticatedUser();
    
    const responses = await DataStore.query(EyepieceThreeResponse, (r) =>
      r.username("eq", user.username)
    );
    let users = await DataStore.query(Users, (d) =>
      d.email("eq", user.attributes.email)
    );
    if (users.length>0){
      const school = users[0].school;
      setSchool(school);
    }
    setSubmitted(responses.length > 0);
    
  }, []);

  return (
    <Fragment>
      <Container>
        {submitted && (
          <Box marginBottom="20px">
            You successfully submitted your response. Go to the results to see
            your data selfie.
          </Box>
        )}
        {school && (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6">
                Share the survey with your colleagues
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                value={encodeURI(window.location.origin + `/dataselfie/${school}`)}
                label="Survey link"
              />
            </Grid>
            <Grid item xs={4}>
              <Button
                
                href={encodeURI(window.location.origin + `/dataselfie/${school}`)}
                variant="contained" color="primary" 
                target="_blank"
              >
                Go to the Link
              </Button>
            </Grid>
          </Grid>
        )}
      </Container>
    </Fragment>
  );
}

export default EyepieceThreeSurvey;
